import { APIData, appFetch } from ".";

export const projectsAPI = {
  fetchPage(page: number) {
    return appFetch<APIData<Project[]>>("/projects?page=" + page);
  },
};
